















import Vue from 'vue';
import { WebRequestStatus } from '../models';

export default Vue.extend({
  props: {
    status: {
      type: Number,
      validator: (value: number) => {
        return WebRequestStatus[value] != undefined;
      }
    }
  },
  computed: {
    isInProgress() {
      return this.status == WebRequestStatus.IN_PROGRESS;
    },
    isReady() {
      return this.status == WebRequestStatus.READY;
    },
    isFailure() {
      return this.status == WebRequestStatus.FAILURE;
    },
    isSuccess() {
      return this.status == WebRequestStatus.SUCCESS;
    }
  }
});
